import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';
import {checkForgotPasswordKey, setNewPassword} from "../actions";
import SectionTitle from "../../Layout/components/SectionTitle";
import SetNewPasswordForm from "./SetNewPasswordForm";
import {withLocalize} from 'react-localize-redux';
import translations from '../translations/translations_set_new_password';
import ReactHtmlParser from 'react-html-parser';

class SetNewPasswordContainer extends Component {
    state = {
        errors: {},
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        if (this.props.auth.isAuthenticated) {
            this.props.history.push('/');
        }

        const key = this.props.match.params.key;
        const idUser = this.props.match.params.user;

        this.props.checkForgotPasswordKey(key, idUser);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.errors !== this.props.errors) {
            this.setState({
                errors: this.props.errors,
            });
        }
    }

    render() {
        const {errors} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};
        const {checkForgotPasswordKeyLoading} = this.props.auth;

        const pageTitle = this.props.translate('auth_set_new_password.page_title') + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        return (
            <Fragment>
                {checkForgotPasswordKeyLoading || Object.getOwnPropertyNames(errors).length > 0 ? (
                    <Fragment>
                        <Helmet
                            bodyAttributes={{
                                class: 'set-new-password vertical-content-force-height-100'
                            }}
                        >
                            <title>{pageTitle}</title>
                        </Helmet>
                        <div className="container">
                            <div className="row mt-0 mb-0 align-items-center" style={{height: '100%'}}>
                                <div className="col-6 col-sm-10 mx-auto">
                                    <div className="text-center">
                                        {checkForgotPasswordKeyLoading &&
                                            <LoadingSpinner />
                                        }
                                        {errorsData.hasOwnProperty('status') && errorsData.status === 401 &&
                                            <SectionTitle cssClass=""
                                                          title={<Fragment>{ReactHtmlParser(this.props.translate('auth_set_new_password.error_message_title', null, {renderInnerHtml: false}))}</Fragment>}
                                                          subtitle={this.props.translate('auth_set_new_password.error_message_subtitle', null, { renderInnerHtml: false })}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                ) : (
                    <Fragment>
                        <Helmet
                            bodyAttributes={{
                                class: 'set-new-password'
                            }}
                        >
                            <title>{pageTitle}</title>
                        </Helmet>
                        <div className="container">
                            <SectionTitle cssClass="page-title"
                                          title={<Fragment>{ReactHtmlParser(this.props.translate('auth_set_new_password.success_message_title', null, {renderInnerHtml: false}))}</Fragment>}
                            />

                            <div className="mt-90 mb-90">
                                <SetNewPasswordForm />
                            </div>
                        </div>
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

SetNewPasswordContainer.propTypes = {
    checkForgotPasswordKey: PropTypes.func.isRequired,
    setNewPassword: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.auth.checkForgotPasswordKeyErrors,
});

export default withRouter(connect(mapStateToProps, {checkForgotPasswordKey, setNewPassword})(withLocalize(SetNewPasswordContainer)));


// WEBPACK FOOTER //
// ./src/features/Auth/components/SetNewPasswordContainer.js